import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, tap } from "rxjs/operators";
import { Notification } from "src/app/notifications/notification";
import { NotificationActions } from "src/app/notifications/state/actions";
import { I18nService } from "../services";
import { i18nActions } from "./actions";

@Injectable()
export class i18nEffects {
  constructor(private actions$: Actions, private service: I18nService) {}

  toggleLanguage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(i18nActions.toggleLanguage),
      tap((/*action*/) => this.service.useNext()),
      map((/*action*/) => {
        const notification = {
          content: "toggleLanguage_message"
        } as Notification;
        return NotificationActions.showNotification({ notification });
      })
    );
  });
}
